import React, {useState, useEffect} from 'react';
import ReactDOM from 'react-dom';

function Portal(props: { children?: React.ReactNode, element?: string, className?: string }) {
    const {children, className = 'root-portal', element = 'div'} = props
    const [container] = useState(() => {
        const el = document.createElement(element)
        el.classList.add(className)
        return el
    })

    useEffect(() => {
        document.body.appendChild(container)
        return () => {
            document.body.removeChild(container)
        }
        // eslint-disable-next-line
    }, [])

    return ReactDOM.createPortal(children, container)
}


export default Portal
